import { CRUDEntity } from "../../abstracts/CRUDEntity";


export class BillingSettings extends CRUDEntity{
    constructor(){
        super();
        this.entityClass = 'billing-setting';
        this.urlRoot = '/settings/billing';
        this.sectionRootUrl = '/settings';
    }
}
